import { LoadingSkeleton } from '@eventbrite/legacy-infra.loading-skeleton';
import React from 'react';
import styles from './EventCardTypographyLoading.module.scss';

interface EventCardTypographyLoadingProps {
    variant: string | undefined;
    width: string;
}

const loadingMap = {
    'body-lg': styles['loading-skeleton-lg'],
    'body-lg-bold': styles['loading-skeleton-lg'],
    'body-md': styles['loading-skeleton-md'],
    'body-md-bold': styles['loading-skeleton-md'],
    'body-sm': styles['loading-skeleton-sm'],
    'body-sm-bold': styles['loading-skeleton-sm'],
} as { [key: string]: string };

/**
 * Migrated from eb-ui [event-renderer@2.77.0](https://github.com/eventbrite/eb-ui/tree/0aa9a7fa029a651639fe039ab2ef3e88f2f09fd3/packages/attendee/event-renderer/src/components/EventCardTypographyLoading)
 */
export const EventCardTypographyLoading: React.FunctionComponent<
    EventCardTypographyLoadingProps
> = ({ variant = 'body-md', width }) => {
    const loadingClassName = loadingMap[variant];

    return (
        <div className={loadingClassName}>
            <LoadingSkeleton height="100%" width={width} />
        </div>
    );
};
